<template>
  <div>
    <!-- 添加 -->
    <div class="Examin_view">
      <el-dialog
        title="添加考生"
        :visible.sync="dialogVisibleObj.addExamineeShow"
        :close-on-click-modal="false"
        :destroy-on-close="true"
        :before-close="handleBeforeClose"
      >
        <div class="examin_mian">
          <div class="examin_head">
            <el-form
              :label-position="labelPosition"
              label-width="80px"
              :model="formLabelAlign"
              ref="formLabelAlign"
            >
              <el-form-item label="姓名：" prop="name">
                <el-input
                  v-model.trim="formLabelAlign.name"
                  placeholder="请输入考生姓名"
                ></el-input>
              </el-form-item>
              <el-form-item label="账号：" prop="account">
                <el-input
                  v-model.trim="formLabelAlign.account"
                  placeholder="请输入考生账号"
                ></el-input>
              </el-form-item>
              <el-form-item label="科室：" prop="department">
                <el-select
                  v-model="formLabelAlign.department"
                  clearable
                  filterable
                  multiple
                  collapse-tags
                  placeholder="全部"
                  @change="searchChang()"
                >
                  <el-option label="全部" value=""></el-option>
                  <el-option
                    v-for="item in keshioptions"
                    :key="item.DepartmentID"
                    :label="item.DepartmentName"
                    :value="item.DepartmentName"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="职称：" prop="region">
                <el-select
                  v-model="formLabelAlign.region"
                  placeholder="全部"
                  multiple  
                  collapse-tags
                  @change="searchChang()"
                >
                  <el-option label="全部" value=""></el-option>
                  <el-option
                    v-for="item in zhichengoptions"
                    :key="item.PTitle"
                    :label="item.PTitle"
                    :value="item.PTitle"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="职位：" prop="position">
                <el-select
                  v-model="formLabelAlign.position"
                  placeholder="全部"
                  multiple
                  collapse-tags
                  @change="searchChang()"
                >
                  <el-option label="全部" value=""></el-option>
                  <el-option
                    v-for="item in zhiweioptions"
                    :key="item.Position"
                    :label="item.Position"
                    :value="item.Position"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <!-- <el-form-item label="分组：" prop="department">
                <el-select
                  v-model="formLabelAlign.gourpId"
                  clearable
                  placeholder="全部"
                  @change="searchChang()"
                >
                  <el-option label="全部" value=""></el-option>
                  <el-option
                    v-for="item in gourpoptions"
                    :key="item.groupID"
                    :label="item.groupName + '（' + item.count + '人）'"
                    :value="item.groupID"
                  >
                  </el-option>
                </el-select>
              </el-form-item> -->
            </el-form>
            <div class="query_btn">
              <el-button
                type="primary"
                icon="el-icon-search"
                class="searchbtn"
                @click="searchBtn"
                >搜索</el-button
              >
              <el-button
                icon="el-icon-refresh"
                class="searchbtn sonbtn"
                @click="resetForm('formLabelAlign')"
                >重置</el-button
              >
            </div>
          </div>
          <!-- 表格 -->
          <div class="examinee_form" v-loading="loading">
            <p class="">
              已选{{ isslectstudentnum.length }}人，科室{{ this.unique() }}个
            </p>
            <el-table
              ref="multipleTable"
              :data="getData"
              style="width: 100%"
              :row-class-name="tableRowClassName"
              @select="handleSelectionChange"
              @select-all="handleSelectionChange"
              @selection-change="handleSelectionChange"
              :row-key="(row) => row.UserID"
              :header-cell-style="{
                'background-color': '#EEEEEE',
                color: '#333333',
                height: '60px',
              }"
            >
              <el-table-column
                type="selection"
                width="80"
                :reserve-selection="true"
              ></el-table-column>
              <el-table-column label="序号" width="80px">
                <template slot-scope="scope">
                  {{ scope.$index + 1 + currentPage3 * pageSize }}
                </template>
              </el-table-column>
              <el-table-column
                v-for="(item, index) in formColumns"
                :key="index"
                :prop="item.prop"
                :label="item.label"
                :width="item.width"
                height="150"
                label-height="50"
                align="center"
              >
              </el-table-column>
            </el-table>
          </div>
          <!-- 分页 -->
          <div class="foot_box">
            <div class="foot_pagetions">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage1"
                :page-size="pageSize"
                :page-sizes="pagesizesarr"
                layout="prev, pager, next,sizes, jumper"
                :total="total"
                class="pagination"
              >
              </el-pagination>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancel">取 消</el-button>
          <el-button type="primary" @click="certain">确 定</el-button>
        </span>
      </el-dialog>
    </div>

    <!-- 二维码 -->
    <div class="delete_view">
      <el-dialog
        title="在线考试二维码生成"
        :visible.sync="dialogVisibleObj.QrlncompleteHint"
      >
        <div class="delete_mian">
          <p>【试卷名称】在线考试已生成成功</p>
          <!-- <img src="@/assets/code.png" alt="" /> -->
          <p>扫一扫进行手机答题</p>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            @click="dialogVisibleObj.QrlncompleteHint = false"
            >点击下载</el-button
          >
        </span>
      </el-dialog>
    </div>

    <!-- 删除 -->
    <div class="delete">
      <el-dialog title="温馨提示" :visible.sync="dialogVisibleObj.batchDelete">
        <p v-if="deleteState == 0">
          此操作将删除"{{ $parent.currentRowData.RealName }}"考生，是否继续
        </p>
        <p v-else-if="deleteState == 1">此操作将批量删除考生，是否继续</p>
        <p v-else-if="deleteState == 2">当前还未选择考生，请选择考生!</p>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibleObj.batchDelete = false"
            >取 消</el-button
          >
          <el-button type="primary" @click="isdelect" v-if="deleteState == 0"
            >确 定</el-button
          >
          <el-button
            type="primary"
            @click="delectArr"
            v-else-if="deleteState == 1"
            >确 定</el-button
          >
          <el-button
            type="primary"
            @click="dialogVisibleObj.batchDelete = false"
            v-else-if="deleteState == 2"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import getstudentlist from "@/api/questionbank";
export default {
  data() {
    return {
      initdata: "", //默认数据。
      dialogVisibleObj: {
        addExamineeShow: false, // 添加考生
        addexaminPaperShow: false, // 从试卷添加考生
        QrlncompleteHint: false, // 二维码
        batchDelete: false, // 删除
        isfirstopen: true,
      },
      deleteState: 0, //弹窗是否批量状态
      labelPosition: "right",
      formLabelAlign: {
        name: "", //考生姓名
        account: "", //考生账号
        department: "", //科室
        gourpId: "", //分组id
        region: "", //职称
        position: "", //职位
      },
      getDataCondition: {
        name: "", //考生姓名
        account: "", //考生账号
      },
      formExamin: {
        name: "",
      },
      getData: [],
      formColumns: [
        {
          prop: "RealName",
          label: "考生姓名",
          // width: "90px",
        },
        {
          prop: "UserName",
          label: "考生账号",
          // width: "90px",
        },
        {
          prop: "DepartmentName",
          label: "科室名称",
          // width: "90px",
        },
        {
          prop: "PTitle",
          label: "职称",
          // width: "90px",
        },
        {
          prop: "Position",
          label: "职位",
          // width: "90px",
        },
        {
          prop: "Birthday1",
          label: "出生日期",
          width: "200px",
        },
        {
          prop: "JobDate",
          label: "工作年限",
          // width: "90px",
        },
      ],
      currentPage3: 0, //  当前页数
      currentPage1: 1, //绑定的页数。
      pageSize: 5,
      total: 100,
      loading: true,
      pagesizesarr: [5, 10, 20, 50, 100],
      isnowselectdate: {}, //当前选中的数据对象数组。
      isselectstudent: "", //选中的考生信息
      keshioptions: [], //全部科室的列表
      gourpoptions: [],
      zhichengoptions: [], //全部职称的列表
      zhiweioptions: [], //全部职位的列表
      isslectstudentnum: "", //选中考生总人数
      multipleSelection: [],
      multipleArr: [], // 选中的状态数组
    };
  },
  props: ["currentRow"],
  methods: {
    // 表格背景颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "success-row";
      } else if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },
    resetForm(formLabelAlign) {
      // 重置
      this.loading = true;
      this.getDataCondition.name = "";
      this.getDataCondition.account = "";
      this.$refs[formLabelAlign].resetFields();
      this.submit();
    },
    // chang搜索
    searchChang() {
      this.loading = true;
      this.submit();
    },
    // 搜索 ===>试卷
    searchBtn() {
      this.currentPage3 = 0;
      this.loading = true;
      if (this.formLabelAlign.name) {
        this.getDataCondition.name = this.formLabelAlign.name;
      } else {
        this.getDataCondition.name = "";
      }
      if (this.formLabelAlign.account) {
        this.getDataCondition.account = this.formLabelAlign.account;
      } else {
        this.getDataCondition.account = "";
      }
      this.submit();
    },

    // 批量删除
    delectArr() {
      this.$parent.getData = this.$parent.getData.filter((item) => {
        let istrueindex = this.$parent.multipleSelection.findIndex((items) => {
          return items.UserID == item.UserID;
        });
        return istrueindex === -1;
      });
      this.$parent.list_vip = this.$parent.list_vip.filter((item) => {
        let istrueindex = this.$parent.multipleSelection.findIndex((items) => {
          return items.UserID == item.UserID;
        });
        return istrueindex === -1;
      });
      if (this.$parent.list_vip.length == 0) {
        this.$parent.list_vip = JSON.parse(
          JSON.stringify(this.$parent.getData)
        );
      }
      this.$parent.isShow = false; // 展示全部数据
      this.dialogVisibleObj.batchDelete = false;
    },
    // 删除
    isdelect() {
      let val = this.$parent.currentRow;
      this.$parent.getData.splice(val, 1); //删除数据源ID
      this.$parent.list_vip.splice(this.$parent.currentRowData.index, 1); //删除数据源ID
      console.log(this.$parent.getData.length, this.$parent.list_vip.length);
      this.$parent.input = "";
      if (this.$parent.list_vip.length == 0) {
        this.$parent.list_vip = JSON.parse(
          JSON.stringify(this.$parent.getData)
        );
      }
      this.dialogVisibleObj.batchDelete = false;
    },
    isNotSet() {
      this.getData.map((item) => {
        for (let ztiem in item) {
          if (item[ztiem] === "" || item[ztiem] === null) {
            item[ztiem] = "未设置";
          }
        }
        item.Birthday1 = this.$moment(item.BeginTime).format(
          "YYYY/MM/DD HH:mm"
        );
      });
    }, // 初始字段为空时状态
    // 分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.loading = true;
      this.submit(); // 重新发起请求
    },
    handleCurrentChange(val) {
      this.currentPage3 = val - 1;
      this.loading = true;
      this.submit();
    },
    handleSelectionChange(val) {
      //还有问题
      val = val.filter((item) => {
        return item !== undefined;
      });
      this.multipleArr = JSON.parse(JSON.stringify(val));
      if (
        this.isnowselectdate[this.currentPage3] === undefined &&
        val.length == 0
      ) {
        return;
      } else if (
        this.isnowselectdate[this.currentPage3] !== undefined &&
        val.length != 0
      ) {
        this.isnowselectdate[this.currentPage3] =
          this.isnowselectdate[this.currentPage3].concat(val);
      } else {
        this.isnowselectdate[this.currentPage3] = val;
      }
      let linshiobj = {};
      for (let key in this.isnowselectdate) {
        this.isnowselectdate[key] = this.isnowselectdate[key].filter((item) => {
          if (!linshiobj[item.UserID]) {
            linshiobj[item.UserID] = 1;
            return item;
          }
        });
      }
      this.isslectstudentnum = Object.values(this.isnowselectdate).flat(2);
      this.multipleSelection = Object.values(this.isnowselectdate).flat(
        2
      ).length;
    },
    toggleSelection(rows) {
      return;
      //选中的钩子回选的问题。
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(
            this.getData.find((item) => {
              return item.UserName == row.UserName;
            }),
            true
          );
        });
      }
    },
    async submit() {
      let student = {
        hid: JSON.parse(sessionStorage.getItem("token")).hid,
        UserName: this.getDataCondition.account,
        RealName: this.getDataCondition.name,
        Position: JSON.stringify(this.formLabelAlign.position),
        department: JSON.stringify(this.formLabelAlign.department),
        PTitle: JSON.stringify(this.formLabelAlign.region),
        startTime: "",
        groupID: JSON.stringify(this.formLabelAlign.gourpId),
        endTime: "",
        pageIndex: JSON.stringify(this.currentPage3), //开始页
        pageShow: this.pageSize, //条数
      };
      let res = await getstudentlist.getseekAndCreateExam(student);
      let studentGoup = await getstudentlist.getstudentlist(student);
      if (this.dialogVisibleObj.isfirstopen) {
        this.keshioptions = res.data.Data[1];
        this.zhichengoptions = res.data.Data[3];
        this.zhiweioptions = res.data.Data[2];
        this.gourpoptions = studentGoup.data.Data.data;
        this.dialogVisibleObj.isfirstopen = false;
      }
      this.theEcho(); // 回显已勾中的考生
      setTimeout(() => {
        this.loading = false;
      }, 500);
      this.getData = res.data.Data[0];
      this.total = res.data.Data[4][0].dataPageCount;
      this.isNotSet();
    },
    // 弹窗关闭前触发
    handleBeforeClose(done) {
      this.cancel();
      done();
    },
    cancel() {
      //取消按钮
      if (this.multipleSelection == "" || this.multipleSelection.length == 0) {
        this.dialogVisibleObj.addExamineeShow = false;
      } else {
        this.dialogVisibleObj.addExamineeShow = false;
        this.isnowselectdate = {};
      }
      this.inits();
    },
    // 判断是否有重复
    isRepeat(arr) {
      let ids = [];
      ids = arr.map((value) => value.UserID);
      const idsSet = new Set(ids);
      if (idsSet.size == ids.length) {
        return false;
      } else {
        return true;
      }
    },
    certain() {
      //确定按钮
      this.isselectstudent = Object.values(this.isnowselectdate).flat(2);
      if (this.$parent.getData.length != 0) {
        let puseridarr = this.$parent.getData.map((item) => {
          return item.UserID;
        });
        let fileterisslecte = this.isselectstudent.filter((item) => {
          let res = puseridarr.findIndex((value) => value == item.UserID);
          return res == -1;
        });
        if (fileterisslecte.length == 0) {
          this.$message({
            message: "该考生已经添加了，请添加新的考生",
            type: "warning",
          });
          this.dialogVisibleObj.addExamineeShow = false;
        } else {
          this.$parent.getData.push(...fileterisslecte);
          this.dialogVisibleObj.addExamineeShow = false;
        }
      } else {
        this.$parent.getData = this.isselectstudent;
        this.dialogVisibleObj.addExamineeShow = false;
      }
      // 在编辑的时候list_vip数组会回显，不能直接赋值
      if (this.$parent.typeState == 1 || this.$route.query.state == "jk") {
        // 编辑的时候不能直接替换，保留原有数据
        let arr = JSON.parse(JSON.stringify(this.$parent.getData)); // 编辑回显源有数组
        this.$parent.list_vip = this.$parent.list_vip.concat(arr);
        let type = this.isRepeat(this.$parent.list_vip); // 判断是否重复
        if (type == true) {
          // 有重复的情况去重  编辑后台没给ID，暂时以RealName过滤
          const duplicate = (arr) => {
            let obj = {};
            // console.log(arr,'-----------------??');
            // 2.24  将RealName过滤改成UserID
            arr = arr.reduce((newArr, next) => {
              obj[next.UserID]
                ? ""
                : (obj[next.UserID] = true && newArr.push(next));
              return newArr;
            }, []);
            return arr;
          };
          this.$parent.list_vip = duplicate(this.$parent.list_vip);
        }
        return;
      } else {
        this.$parent.list_vip = JSON.parse(
          JSON.stringify(this.$parent.getData)
        );
      }
      this.$parent.list_vip = JSON.parse(JSON.stringify(this.$parent.getData));
      this.inits();
    },
    unique() {
      console.log(this.isnowselectdate);
      let departArr = Object.values(this.isnowselectdate)
        .flat(2)
        .map((item) => {
          return item.DepartmentName;
        });
      departArr = [...new Set(departArr)];
      return departArr.length;
    },
    inits() {
      //重置数据要放在父组件里面。
      Object.assign(
        this.$data,
        JSON.parse(JSON.stringify(this.$parent.fourPupinitdata))
      );
    },
    theEcho() {
      // 回显已勾中的考生
      this.$nextTick(() => {
        this.$parent.list_vip.forEach((key) => {
          this.getData.forEach((row) => {
            if (row.UserID == key.UserID) {
              this.$refs.multipleTable.toggleRowSelection(row, true);
            }
          });
        });
      });
    },
  },
  computed: {
    newgetdata() {
      return JSON.parse(JSON.stringify(this.getData));
    },
  },
  mounted() {},
  created() {
    this.$parent.fourPupinitdata = JSON.parse(
      JSON.stringify(this.$options.data())
    );
  },
  watch: {
    newgetdata(newval, oldval) {
      this.$nextTick(() => {
        this.toggleSelection(this.isnowselectdate[this.currentPage3]);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.Examin_view {
  box-sizing: border-box;
  .title_box {
    padding-bottom: 9px;
    margin-bottom: 20px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 19px;
    color: #333333;
    border-bottom: 1px solid #abd7ff;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
  ::v-deep .dialog-footer {
    margin-bottom: 30px;
  }
  ::v-deep.el-dialog__footer {
    justify-content: center !important;
    margin-bottom: 50px;
  }
  .el-dialog__footer span > button {
    margin-top: 10px;
    width: 103px;
    height: 42px;
  }
  ::v-deep .el-dialog {
    width: 1400px;
    // height: 688px;
    // overflow-y: scroll;
    border-radius: 5px 5px 0px 0px;
  }
  ::v-deep .el-dialog__header {
    padding: 0px 24px;
  }
  .examin_head {
    padding: 30px 24px 10px 10px;
    display: flex;
    .el-form {
      display: flex;
    }
    .query_btn {
      display: flex;
      .el-button {
        width: 88px;
        height: 40px;
        margin-left: 24px;
      }
    }
  }
  .examinee_form {
    padding: 0px 20px 0px 34px;
    p {
      margin-bottom: 16px;
    }
  }
}
// 删除
.delete {
  ::v-deep .el-dialog {
    width: 300px;
    min-height: 220px;
    border-radius: 5px 5px 0px 0px;
    .input_layout {
      display: flex;
    }
  }
  ::v-deep .el-dialog__header {
    line-height: 0;
  }
  ::v-deep .el-dialog__body {
    padding: 20px 14px;
    p {
      height: 45px;
      // margin-top: 20px;
      line-height: 22px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
    }
  }
  .el-dialog__footer span > button {
    margin-top: 20px !important;
  }
}
// 二维码弹窗
.delete_view {
  box-sizing: border-box;
  .title_box {
    padding-bottom: 9px;
    margin-bottom: 20px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 19px;
    color: #333333;
    border-bottom: 1px solid #abd7ff;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
  ::v-deep .dialog-footer {
    margin-bottom: 30px;
  }
  ::v-deep.el-dialog__footer {
    justify-content: center !important;
  }

  .delete_mian {
    display: flex;
    padding: 20px 0px;
    box-sizing: border-box;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    p:nth-child(1) {
      margin-bottom: 35px;
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: bold;
    }
    p:nth-child(3) {
      margin-top: 30px;
    }
    img {
      width: 230px;
      height: 230px;
    }
  }

  .el-dialog__footer span > button {
    margin-top: 10px;
    width: 103px;
    height: 42px;
  }
}
::v-deep .delete_view .el-dialog {
  width: 496px;
  height: 546px;
  border-radius: 5px 5px 0px 0px;
  .input_layout {
    display: flex;
  }
}
::v-deep .el-dialog__header {
  height: 55px;
  line-height: 55px;
  background: #0084ea;
  opacity: 1;
  border-radius: 5px 5px 0px 0px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  .el-dialog__title {
    color: #fff;
    letter-spacing: 4px;
  }
}
::v-deep .el-dialog__footer {
  padding: 0;
  display: flex;
  justify-content: center;
  align-content: center;
  text-align: center;
  span > button {
    width: 60px;
    height: 32px;
    opacity: 1;
    border-radius: 4px;
    padding: 0px;
    margin-top: 38px;
    &:nth-child(2) {
      margin-left: 90px;
    }
  }
}
::v-deep .el-dialog__body {
  padding: 0;
}
::v-deep .el-dialog__wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
// 分页
.foot_box {
  position: relative;
  height: 88px;
}
.foot_pagetions {
  display: flex;
  position: absolute;
  right: 16px;
  bottom: 30px;
  p {
    text-align: center;
    line-height: 32px;
    font-family: 微软雅黑;
    color: #949494;
  }
  span {
    line-height: 32px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    b {
      color: #ff0000;
    }
  }
}
.pagination {
  ::v-deep .el-pager {
    li {
      border: 1px solid #d9d9d9;
      margin-right: 8px;
      &.active {
        color: #ffffff;
        background-color: #409eff;
        border: none;
      }
    }
  }
}
::v-deep .el-table__body-wrapper {
  height: 240px;
  overflow-y: scroll;
  position: relative;
  scrollbar-face-color: none !important;
  &::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 4px;
  }
  &::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 5px;
    //  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: linear-gradient(
      180deg,
      #64b5ff 0%,
      rgba(199, 228, 255, 1) 100%
    );
  }
  & ::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    // -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background: linear-gradient(
      180deg,
      #64b5ff 0%,
      rgba(199, 228, 255, 1) 100%
    );
  }
}
::v-deep .el-table__header-wrapper {
  position: sticky;
  top: 0;
}
::v-deep .el-dialog__headerbtn .el-dialog__close {
  font-size: 24px;
}
</style>
